import React from "react";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Search, Bell, Sparkles } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [q, setQ] = React.useState("");
  if (!user) return <Navigate to="/login" replace />;

  const onSubmit = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/app/ai-search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div className="flex bg-[#14100c] min-h-screen text-[#f4ede2]">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="sticky top-0 z-20 border-b border-[#33291f] bg-[#14100c]/85 backdrop-blur-xl">
          <div className="flex items-center gap-4 px-8 py-3">
            <form onSubmit={onSubmit} className="flex-1 max-w-2xl relative" data-testid="topbar-search-form">
              <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7a6d5a]" />
              <Input
                data-testid="topbar-search-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder='Ask AI: "warehouses over 100K sqft with tax delinquency near Seattle"'
                className="pl-9 h-9 bg-[#1c1712] border-[#33291f] text-[13px] placeholder:text-[#7a6d5a] focus-visible:ring-1 focus-visible:ring-[#d4a574]"
              />
              <div className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] px-1.5 py-0.5 rounded bg-[#241d16] text-[#d4a574] border border-[#4a3a2b] font-mono">AI</div>
            </form>
            <button data-testid="notif-btn" className="p-2 rounded border border-[#33291f] text-[#b8ac96] hover:text-[#d4a574] hover:border-[#4a3a2b]">
              <Bell size={15} />
            </button>
            <div className="text-[11px] font-mono text-[#7a6d5a] hidden md:block">
              LIVE · <span className="text-[#34d399]">●</span> Ingestion Active
            </div>
          </div>
        </div>
        <div className="px-8 py-6">
          <Outlet />
        </div>
      </main>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
